import AgencyHelper from 'features/Agency/agencyHelper';
import KTFormSearch from 'general/components/OtherKeenComponents/Forms/KTFormSearch';
import KTDropdownFilter from 'general/components/OtherKeenComponents/KTDropdownFilter';
import CustomDateRangePicker, { dateFilter, getDateFilterOption } from 'general/components/Others/CustomDateRangePicker';
import _ from 'lodash';
import PropTypes from 'prop-types';
import UIHelper from 'general/helpers/UIHelper';
import { useMemo, useState } from 'react';
import CustomDropdown2 from 'general/components/Others/CustomDropdown2';
import AppColors from 'general/constants/AppColors';
import AppConfigs from 'general/constants/AppConfigs';
import CustomDateRangePicker2 from 'general/components/Others/CustomDateRangePicker2';

VoucherListFilterView.propTypes = {
    setFilterDropdown: PropTypes.func,
    filterDropdown: PropTypes.object,
    onCancel: PropTypes.func,
    onApply: PropTypes.func,
    setSelectedVoucherBatch: PropTypes.func,
    selectedVoucherBatch: PropTypes.object,
};

function VoucherListFilterView({
    setFilterDropdown,
    filterDropdown,
    onCancel,
    onApply,
    closeDropdown,
    setSelectedVoucherBatch,
    selectedVoucherBatch,
}) {
    // MARK: ---- PROPERTIES ----
    const handleCloseDropdown = () => {
        $('#toggle-batch').dropdown('toggle');
    };
    const dropdownVoucherBatchEl = useMemo(() => {
        return (
            <CustomDropdown2
                id="toggle-batch"
                name="voucherBatchId"
                toggleElement={
                    <button
                        className={`btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between`}
                        type="button"
                    >
                        {filterDropdown?.voucherBatchId ? `VP${filterDropdown?.voucherBatchId?.toString().padStart(8, '0')}` : 'Chọn lô voucher'}
                    </button>
                }
                selectedValue={selectedVoucherBatch}
                dropdownMenuItems={[{ name: 'Lô voucher', role: 'VOUCHER_BATCH' }]}
                getSubItems={async (item) => {
                    return AgencyHelper.API.requestGetVoucherBatchList({
                        page: item?.page || 0,
                        limit: 10,
                        q: item?.q || '',
                    }).then((data) => {
                        return {
                            values: data.voucherBatches?.map((row) => ({
                                id: row?.voucherBatchId,
                                name: `VP${row?.voucherBatchId?.toString().padStart(8, '0')}`,
                                item: row,
                            })),
                            total: data.total,
                        };
                    });
                }}
                dropdownMenuStyle={{ maxHeight: '30vh' }}
                dropdownMenuClassName="overflow-auto w-100"
                onChange={(value) => {
                    setSelectedVoucherBatch(value);
                    const updateFilterDropdown = { ...filterDropdown, voucherBatchId: value?.id };
                    setFilterDropdown(updateFilterDropdown);
                    handleCloseDropdown();
                }}
                isDropdownForm={true}
                titleSearchable={true}
                searchable={true}
                searchFormClassName="mx-3 my-1 search-form-border"
                ignoreConfirmClick={true}
                defaultValue={{
                    name: 'Lô voucher',
                    role: 'VOUCHER_BATCH',
                }}
                footerEl={
                    <div
                        className="p-4 position-sticky sticky-bottom bg-white"
                        style={{
                            borderTop: `1px solid ${AppColors.gray[300]}`,
                        }}
                    >
                        {UIHelper.buildNegativeButton('Bỏ chọn', () => {
                            setSelectedVoucherBatch(null);
                            const updateFilterDropdown = { ...filterDropdown, voucherBatchId: '' };
                            setFilterDropdown(updateFilterDropdown);
                            handleCloseDropdown();
                        })}
                    </div>
                }
            />
        );
    }, [selectedVoucherBatch, filterDropdown]);

    // MARK: ---- METHODS ----
    const handleApplyFilter = () => {
        AgencyHelper.Filter.voucherList = {
            ...AgencyHelper.Filter.voucherList,
            q: filterDropdown.q,
            page: 0,
            voucherBatchId: filterDropdown.voucherBatchId,
            status: filterDropdown.status,
            releaseStatus: filterDropdown.releaseStatus,
            releasedDateFilter: filterDropdown.releasedDateFilter,
            releasedFrom: filterDropdown.releasedFrom,
            releasedTo: filterDropdown.releasedTo,
            expiredDateFilter: filterDropdown.expiredDateFilter,
            expiredFrom: filterDropdown.expiredFrom,
            expiredTo: filterDropdown.expiredTo,
        };
        if (onApply) onApply();
        if (closeDropdown) closeDropdown();
    };
    const handleClearFilter = () => {
        setSelectedVoucherBatch(null);
        AgencyHelper.Filter.voucherList = {
            q: '',
            page: 0,
            limit: AppConfigs.defaultPageLimit,
            voucherBatchId: '',
            status: '',
            releaseStatus: '',
            releasedDateFilter: dateFilter.tatCaThoiGian,
            releasedFrom: '',
            releasedTo: '',
            expiredDateFilter: dateFilter.tatCaThoiGian,
            expiredFrom: '',
            expiredTo: '',
        };
        setFilterDropdown(AgencyHelper.Filter.voucherList);
        if (onCancel) onCancel();
        if (closeDropdown) closeDropdown();
    };
    console.log('filterDropdown:', filterDropdown);
    return (
        <div className='pb-4'>
            <div className='row p-4'>
                <div className="col-12 px-4">
                    <KTFormSearch
                        name="search-bar"
                        placeholder="Theo mã voucher, mã sử dụng"
                        value={filterDropdown.q}
                        onSubmit={(text) => {
                            const updateFilterDropdown = { ...filterDropdown, q: text };
                            setFilterDropdown(updateFilterDropdown);
                        }}
                    />
                </div>
                {/* Mã lô voucher */}
                <div className="col-12 px-4 pt-4">
                    {UIHelper.buildTableColumn('Mã lô voucher')}
                    {dropdownVoucherBatchEl}
                </div>
                {/* Trạng thái voucher */}
                <div className="col-6 py-2 pr-2">
                    <KTDropdownFilter
                        label="Trạng thái voucher"
                        filterKey="status"
                        options={[
                            { name: "Tất cả", value: "" },
                            ...AgencyHelper.Data.voucherStatusOptions,
                        ]}
                        selectedValue={filterDropdown.status}
                        handleChange={(value) => {
                            const updateFilterDropdown = { ...filterDropdown, status: value };
                            setFilterDropdown(updateFilterDropdown);
                        }}
                    />
                </div>
                {/* Trạng thái phát hành */}
                <div className="col-6 py-2 pl-2">
                    <KTDropdownFilter
                        label="Trạng thái phát hành"
                        filterKey="releaseStatus"
                        options={[
                            { name: "Tất cả", value: "" },
                            ...AgencyHelper.Data.voucherStatusOptions,
                        ]}
                        selectedValue={filterDropdown.releaseStatus}
                        handleChange={(value) => {
                            const updateFilterDropdown = { ...filterDropdown, releaseStatus: value };
                            setFilterDropdown(updateFilterDropdown);
                        }}
                    />
                </div>

                {/* Thời gian hết hạn */}
                <div className="col-6 py-2 pr-2">
                    <label htmlFor="filterByDate" className="mb-0 mr-2 font-weight-bolder">
                        Thời gian hết hạn
                    </label>
                    <CustomDateRangePicker2
                        toggleElementBorderRadius={5}
                        alignRight={true}
                        initialValue={
                            filterDropdown.expiredDateFilter?.length > 0
                                ? filterDropdown.expiredDateFilter
                                : dateFilter.tatCaThoiGian
                        }
                        onPressSave={(selectedValue, startDate, endDate) => {
                            const updateFilterDropdown = {
                                ...filterDropdown,
                                expiredFrom: startDate,
                                expiredTo: endDate,
                                expiredDateFilter: selectedValue,
                            };
                            setFilterDropdown(updateFilterDropdown);
                        }}
                    />
                </div>

                {/* Thời gian phát hành */}
                <div className="col-6 py-2 pl-2">
                    <label htmlFor="filterByDate" className="mb-0 mr-2 font-weight-bolder">
                        Thời gian phát hành
                    </label>
                    <CustomDateRangePicker2
                        toggleElementBorderRadius={5}
                        alignRight={true}
                        initialValue={
                            filterDropdown.releasedDateFilter?.length > 0
                                ? filterDropdown.releasedDateFilter
                                : dateFilter.tatCaThoiGian
                        }
                        onPressSave={(selectedValue, startDate, endDate) => {
                            const updateFilterDropdown = {
                                ...filterDropdown,
                                releasedFrom: startDate,
                                releasedTo: endDate,
                                releasedDateFilter: selectedValue,
                            };
                            setFilterDropdown(updateFilterDropdown);
                        }}
                    />
                </div>
            </div>
            {/* actions */}
            <div
                className="px-4 pt-4 pb-0 d-flex align-items-center justify-content-end gap-3"
                style={{
                    borderTop: `1px solid ${AppColors.gray[200]}`,
                }}
            >
                {UIHelper.buildNegativeButton('Đặt lại mặc định', handleClearFilter)}
                {UIHelper.buildGreenButton('Áp dụng', handleApplyFilter)}
            </div>
        </div>
    );
}

export default VoucherListFilterView;
